import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/pages/themes.css";
import router from "./routes/routes";
import { PermissionProvider } from "./context/PermissionContext";

function App() {
  return (
    <ThemeProvider>
      <PermissionProvider>
        <RouterProvider router={router} />
      </PermissionProvider>
    </ThemeProvider>
  );
}

export default App;

